/**
 * Created by Victor Rojo on 21/4/20.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

@Injectable()
export class IPetrolDemoService{

  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getCredentials(): Promise<any>{
    let url = "api/v1/3pi/ipetroldemo";
    return this.http.get(url)
      .toPromise()
  }
}
